import { useCallback, useEffect, useState } from 'react';

/**
 * Estado de colapso de la sidebar, compartido por los tres estilos (ADR-2026-07-30-sidebar-colapsable-tres-estilos-estado).
 *
 * Se guarda en `localStorage` con una clave única para el preview: al saltar de un
 * estilo a otro con la pastilla, la sidebar queda como estaba. Comparar los tres
 * "abiertos" o los tres "colapsados" es justamente lo que se quiere mirar.
 *
 * Clave propia (no la del Sidebar real, `atlas-sidebar-collapsed`): el preview no
 * debe cambiarle el estado de la app.
 */
const CLAVE = 'atlas:estilos-sidebar-colapsada';

export function useSidebarColapsable() {
  const [colapsada, setColapsada] = useState<boolean>(() => {
    try {
      // `'min'` quedó guardado por una versión de un día (2026-09-16) que tenía una
      // tercera posición; se lee como colapsada.
      const v = localStorage.getItem(CLAVE);
      return v === '1' || v === 'min';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(CLAVE, colapsada ? '1' : '0');
    } catch {
      /* modo privado / storage bloqueado: el estado vive sólo en memoria */
    }
  }, [colapsada]);

  const alternar = useCallback(() => setColapsada((v) => !v), []);
  /** Cerrarla sin alternar: lo pide una pantalla que quiere el ancho (el lienzo del Agente). */
  const colapsar = useCallback(() => setColapsada(true), []);
  /** Abrirla entera sin alternar: lo pide el Catálogo al salir de su sesión. */
  const expandir = useCallback(() => setColapsada(false), []);

  return { colapsada, alternar, colapsar, expandir };
}
